import { UnionValueMap } from '../../../types/union-map';
import { ActionName, ActionType } from '../core-actions';
import { initializeRemoteFlags } from './remote-flags-action-creators';

/**
 * Action types
 */

type RemoteFlagsActionName = ActionName<'InitializeRemoteFlags', 'Error' | 'Success' | 'Failed'>;

export type RemoteFlagsActionType = ActionType<'INITIALIZE_REMOTE_FLAGS', '_ERROR' | '_SUCCESS' | '_FAILED'>;

export const RemoteFlagsActionType: UnionValueMap<RemoteFlagsActionName, RemoteFlagsActionType> = {
    InitializeRemoteFlags: 'INITIALIZE_REMOTE_FLAGS',
    InitializeRemoteFlagsError: 'INITIALIZE_REMOTE_FLAGS_ERROR',
    InitializeRemoteFlagsSuccess: 'INITIALIZE_REMOTE_FLAGS_SUCCESS',
    InitializeRemoteFlagsFailed: 'INITIALIZE_REMOTE_FLAGS_FAILED',
};

/**
 * Action shorthands
 */

export type InitializeRemoteFlagsAction = ReturnType<typeof initializeRemoteFlags>;
